import { jsx as a, jsxs as c } from "react/jsx-runtime";
import { FieldErrorAndDescription as x, toast as $ } from "@systemeio/ui";
import { UploadIcon as G } from "@systemeio/ui/icons";
import { useRef as O, useState as y, Children as U } from "react";
import { useTranslation as W } from "../../i18n.mjs";
import { FileDropZoneVariantEnum as q, variantClassName as z } from "./constants.mjs";
import { twMerge as d } from "tailwind-merge";
import { formatAcceptTypeForInput as B, isAcceptTypeValid as H } from "../../utils/file-input-accept-types.mjs";
function ae(D) {
  const {
    acceptTypes: l,
    children: n,
    dropZoneClassName: N,
    className: w,
    disabled: C,
    error: F,
    variant: I = q.Medium,
    label: T,
    icon: _ = /* @__PURE__ */ a(G, {}),
    isPreFetching: m,
    toastText: u,
    labelClassName: E,
    openNativeWindow: S = !0,
    multiple: g = !1,
    displayItemsInGrid: j = !1,
    onSelect: k,
    onClick: i
  } = D, t = m || C, { t: h } = W(), v = O(null), [A, s] = y(!1), [Z, L] = y(), M = (e) => {
    var r;
    e.preventDefault(), !t && (i == null || i(), S && ((r = v.current) == null || r.click()));
  }, p = (e) => {
    const r = [], o = [];
    for (let f of e)
      l && !H(f.type, l) ? r.push(`${f.name} - ${h("file_manager.file_upload.file_not_supported")}`, /* @__PURE__ */ a("br", {})) : o.push(f);
    L(r), o.length && (k(o), u && $.success(u));
  }, b = (e) => {
    e.preventDefault(), s(!0);
  }, P = (e) => {
    e.preventDefault(), s(!1);
  }, R = (e) => {
    e.preventDefault(), e.stopPropagation();
    const { files: r } = e.dataTransfer;
    if (g)
      p(r);
    else {
      const o = r[0];
      o && p([o]);
    }
    s(!1);
  }, V = (e) => {
    e.target.files && p(e.target.files), e.target.value = "";
  };
  return /* @__PURE__ */ c("div", { className: d("font-medium", w), children: [
    /* @__PURE__ */ a(
      "input",
      {
        ref: v,
        type: "file",
        className: "invisible absolute h-1 w-0",
        onChange: V,
        disabled: t,
        accept: l && B(l),
        multiple: g
      }
    ),
    /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        className: d(
          "bg-background-primary ring-brand-primary flex min-h-[60px] w-full flex-row flex-wrap gap-3 rounded-lg border border-dashed outline-hidden ring-offset-1 focus-visible:ring-2",
          A ? "border-brand-primary" : "border-text-secondary",
          z[I],
          m && "animate-pulse",
          t ? "cursor-not-allowed" : "hover:border-brand-primary cursor-pointer",
          N
        ),
        onDragStart: t ? void 0 : b,
        onDragLeave: t ? void 0 : P,
        onDrop: t ? void 0 : R,
        onDragOver: t ? void 0 : b,
        onClick: M,
        children: [
          !!U.count(n) && (j ? /* @__PURE__ */ a(
            "div",
            {
              className: "grid w-full content-start gap-y-6 gap-x-8 [grid-template-columns:repeat(auto-fit,minmax(200px,1fr))]",
              children: n
            }
          ) : /* @__PURE__ */ a("div", { className: "flex w-full flex-wrap gap-3", children: n })),
          /* @__PURE__ */ c(
            "div",
            {
              className: d(
                "flex w-full flex-col items-center justify-center gap-1",
                E
              ),
              children: [
                _,
                T ?? h("file_manager.file_upload.drop_files_here")
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ a(x, { error: Z, errorClassName: "text-center mt-2" }),
    /* @__PURE__ */ a(x, { error: F, errorClassName: "text-center mt-2" })
  ] });
}
export {
  ae as FileDropZone
};
